import $ from 'jquery';
import appAjax from '../helpers/ajax';
import appUi from '../helpers/ui';

export const KEY_DEVICE_NAME = 'device_name';
export const KEY_ACCESS_TOKEN = 'access_token';

function ModalLogin({onAuthenticated}) {
    const onSubmit = (e) => {
        e.preventDefault();

        var elForm = e.target;
        var formData = {};

        formData.user = $(elForm).find('input[name=user]').val();
        formData.pswd = $(elForm).find('input[name=pswd]').val();
        formData.device_name = $(elForm).find('input[name=device_name]').val();
        localStorage.setItem(KEY_DEVICE_NAME, formData.device_name);

        var url = appAjax.apiBaseUrl + '/auth/access-token';

        appAjax._ajax_send(formData, {
            beforeSend: function() {
                $(elForm).find('button, input[type=text], input[type=password]').attr('disabled', 'disabled');
            },
            success: function(response) {
                //-- Save to localstorage
                localStorage.removeItem(KEY_ACCESS_TOKEN);
                localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);

                if (appAjax.FCM_TOKEN) {
                    appAjax.saveFcmToken(appAjax.FCM_TOKEN, (response) => {
                    //-- Callback if needed after saving token to backend
                    });
                }

                $('#web_modal_auth').modal('hide');
                // var newLine = $('<div class="media media-meta-day text-success" />').text(response.message).appendTo(appAjax.CHATBOX);
                onAuthenticated();
                $("#web_btn_doauth").hide();

                $("#chatinput").trigger('focus');
            },
            error: function(response) {
                appUi.uiAlert(response.message, null, 'Failed', 'error');
            },
            always: function() {
                $(elForm).find('button, input[type=text], input[type=password]').removeAttr('disabled');
            }
        }, 'Authenticating...', url);

        return false;
    };

  return (
    <div
    className="modal"
    style={{ display: "none" }}
    tabIndex={-1}
    id="web_modal_auth"
    data-backdrop="static" data-keyboard="false"
    >
    <div className="modal-dialog">
        <div className="modal-content">
        <div className="modal-header">
            <h5 className="modal-title">Auth</h5>
            <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            >
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form action="#" method="POST" id="web_modal_form_auth" onSubmit={onSubmit}>
            <div className="modal-body">
            {/* Horizontal login form */}
            <div className="form-group row">
                <label
                htmlFor="web_modal_txtdevicename"
                className="col-sm-2 col-form-label"
                >
                Device
                </label>
                <div className="col-sm-10">
                <input
                    type="text"
                    className="form-control"
                    id="web_modal_txtdevicename"
                    required
                    name="device_name"
                    placeholder="Device Name"
                />
                </div>
            </div>

            <div className="form-group row">
                <label
                htmlFor="web_modal_txtusername"
                className="col-sm-2 col-form-label"
                >
                Username
                </label>
                <div className="col-sm-10">
                <input
                    type="text"
                    className="form-control"
                    id="web_modal_txtusername"
                    required
                    name="user"
                    placeholder="Username"
                />
                </div>
            </div>
            <div className="form-group row">
                <label
                htmlFor="web_model_txtpsw"
                className="col-sm-2 col-form-label"
                >
                Password
                </label>
                <div className="col-sm-10">
                <input
                    type="password"
                    className="form-control"
                    id="web_model_txtpsw"
                    required
                    name="pswd"
                    placeholder="Password"
                />
                </div>
            </div>
            </div>
            <div className="modal-footer">
            <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
            >
                Close
            </button>
            <button type="submit" className="btn btn-primary">
                <i className="fa fa-lock" /> Login
            </button>
            </div>
        </form>
        </div>
    </div>
    </div>

  );
}

export default ModalLogin;
